export const VIDEO_GROUP_TITLES = {
  MY_VIDEOS: "My Videos",
  MY_WORDS: "My Words",
  DISCOVER: "Discover Videos",
} as const;

export const VIDEO_PAGE_TITLES = {
  MY_FAVORITES: "Favorites",
  MY_STUDYING: "Studying",
  MY_IMPORTS: "Imports",
  NEW_VIDEO: "Add Video",
  DISCOVER: "All",
  REVIEW: "Review",
  KNOWN: "Known",
} as const;

export const VIDEO_SORT_COLUMNS = {
  ADDED_ON: "addedOn",
} as const;

export const VIDEO_ALL_SORT_COLUMNS = {
  VIEWS: "views",
  LIKES: "likes",
  PUBLISHED_ON: "publishedOn",
} as const;

export const VALID_SORT_COLUMNS = {
  ...VIDEO_ALL_SORT_COLUMNS,
  ...VIDEO_SORT_COLUMNS,
};

export const JLPT_LEVELS = {
  N1: 1,
  N2: 2,
  N3: 3,
  N4: 4,
  N5: 5,
} as const;

export const JLPT_TEXT_WEIGHTS = {
  5: "font-normal", // N5 - Regular (400)
  4: "font-medium", // N4 - Medium (500)
  3: "font-semibold", // N3 - Semibold (600)
  2: "font-bold", // N2 - Bold (700)
  1: "font-extrabold", // N1 - Extra Bold (800)
} as const;

export const JLPT_LEVELS_DESCRIPTIONS = {
  5: "Beginner",
  4: "Intermediate",
  3: "Advanced",
  2: "Expert",
  1: "Master",
} as const;
